export enum OnboardingWorkMode {
  Alone = 1,
  HaveEmployees = 2,
  WithContractors = 3,
}
